import SelectNormal from "../../select/SelectNormal";
import t from "../../../../Localization";
import React, {Component, Fragment} from "react";
import classNames from "classnames";
import SVG from "react-inlinesvg";
import arrowUp from "../../../../assets/svg/actions/icn-arrow-up.svg";
import arrowDown from "../../../../assets/svg/actions/icn-arrow-down.svg";
import DetailsColumn from "./DetailsColumn";

class CareerStats extends DetailsColumn {
    state = {
        selectedSeason: -1,
    };

    renderBody = () => {
        const {data, page} = this.props;
        const seasons = data.map(item => item.season ?? {name: 'Overall Career', id: -1}).sort((a, b) => {
            if (a.id === -1)
                return -1;

            if (typeof a.value === 'number' && typeof b.value !== 'number')
                return -1;

            return a.value === b.value ? 0 : a < b ? -1 : 1;
        });
        const options = seasons.map(season => ({label: season.name, value: season.id}));

        return (
            <div className="key-stats-from-body">
                <SelectNormal color="flat" type="sm" options={options} defaultValue={options[0]} onChange={this.handleFilterChange}/>
                {data
                    .filter(item => (item?.season?.id ?? -1) === this.state.selectedSeason)
                    .map((item, index) => (
                        <Fragment key={index}>
                            <CareerStats.Value title="Goals Scored" value={item.goalsScored} page={page}/>
                            <CareerStats.Value title="Shoot Accuracy" value={item.shootAccuracy} page={page}/>
                            <CareerStats.Value title="Passing Accuracy" value={`${item.passingAccuracy} %` } page={page}/>
                            <CareerStats.Value title="Tackle success rate" value={`${item.tackleSuccessRate} %`} page={page}/>
                        </Fragment>
                    ))}
            </div>
        );
    };

    handleFilterChange = (option) => {
        this.setState({
            ...this.state,
            selectedSeason: option.value,
        });
    };


    static defaultProps = {
        headerTitle: "Key Stats from:"
    };

    getComponentClassName = () => 'key-stats-from';
}

class CareerStatsValue extends Component {
    render = () => {
        const {page, title, value} = this.props;

        return (
            <Fragment>
                <div className="title"> {title} </div>
                <div className="value">
                    {value}
                    {/*{*/}
                    {/*    page === 'watchlist' && object.track ? (*/}
                    {/*        <span className={classNames("track", object.track.status)}><SVG src={object.track.status == 'up' ? arrowUp : arrowDown}/>{object.track.value}</span>*/}
                    {/*    ) : null*/}
                    {/*}*/}
                </div>
            </Fragment>
        )
    };
}

CareerStats.Value = CareerStatsValue;

export default CareerStats;
